import { useState } from "react";

export type ItemWithStatus<T> = T & {
  statusId?: string;
};

export function useItemStatusList<
  T extends {
    id: string;
  },
>(items: ItemWithStatus<T>[]) {
  const [statusMap, setStatusMap] = useState<
    Record<string, string | undefined>
  >(() => {
    return items.reduce<Record<string, string | undefined>>((acc, item) => {
      if (item.statusId) {
        acc[item.id] = item.statusId;
      }
      return acc;
    }, {});
  });

  const itemsWithStatus: Array<ItemWithStatus<T>> = items.map((item) => ({
    ...item,
    statusId: statusMap[item.id],
  }));

  const handleStatusChange = (itemId: string, statusId?: string) => {
    setStatusMap((prevStatusMap) => ({
      ...prevStatusMap,
      [itemId]: statusId,
    }));
  };

  return {
    itemsWithStatus,
    handleStatusChange,
  };
}
